import { AlertLevel } from '@jupiterone/jupiter-types';
import { theme } from '@jupiterone/jupiter-web-toolkit';
const colorByAlertLevel = (alertLevel: AlertLevel) => {
  switch (alertLevel) {
    case AlertLevel.CRITICAL:
      return (theme.palette as any).red[500];
    case AlertLevel.HIGH:
      return (theme.palette as any).yellow[900];
    case AlertLevel.MEDIUM:
      return (theme.palette as any).yellow[700];
    case AlertLevel.LOW:
      return (theme.palette as any).coolGrey[300];
    case AlertLevel.INFO:
      return (theme.palette as any).blue[600];
    default:
      return (theme.palette as any).coolGrey[500];
  }
};

export default colorByAlertLevel;
